import { Component, EventEmitter, Inject, inject, Input, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { ToolbarService, WordExportService } from '@syncfusion/ej2-angular-documenteditor';
import { DocumentViewerService } from 'src/app/services/document-viewer.service';
import { TypeDocument } from 'src/app/models/document-viewer';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActionDialogComponent } from '../action-dialog/action-dialog.component';
import { PdfViewerComponent } from '../pdf-viewer/pdf-viewer.component';
import { BeforeSaveEventArgs, SaveCompleteEventArgs, SpreadsheetComponent, SpreadsheetModule } from '@syncfusion/ej2-angular-spreadsheet';
import { HttpClient } from '@angular/common/http';
import { DestinationFolderDialogDesktopComponent } from '../destination-folder-dialog-desktop/destination-folder-dialog-desktop.component';
import { ActionSheetController } from '@ionic/angular';
import { BackButtonService } from 'src/app/services/back-button.service';
import { NgClass, NgIf } from '@angular/common';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { ENVIRONMENT, Environment } from '@shared/environment';

/**
 * Document Editor Component
 */
@Component({
	selector: 'app-excel-viewer',
	templateUrl: './excel-viewer.component.html',
	styleUrls: ['./excel-viewer.component.scss'],
	encapsulation: ViewEncapsulation.None,
	providers: [ToolbarService, WordExportService],
	imports: [NgIf, MatProgressSpinnerModule, MatButtonModule, MatIconModule, SpreadsheetModule, NgClass],
	standalone: true,
})
export class ExcelViewerComponent implements OnInit {
	@Input('isMobile') isMobile: boolean = false;
	isLoading = false;
	@Input('name') name: any;
	@Input('id') id: any;
	@Input('document') document: any;
	@Input('jobId') jobId: any;
	@Input('haveChooseDestinationFolder') haveChooseDestinationFolder = false;

	@Output('closed') closed = new EventEmitter<any>();

	@ViewChild('spreadsheet', { static: true }) public spreadsheetObj: SpreadsheetComponent;
	public culture = 'en-US';
	heightWindow = window.innerHeight - 66;

	isSaveAsPdf = false;
	parentId = null;
	doctype = 'excel';

	private readonly environment = inject<Environment>(ENVIRONMENT);

	constructor(
		private documentViewerService: DocumentViewerService,
		public dialog: MatDialog,
		private snackBar: MatSnackBar,
		private http: HttpClient,
		private dialogRef: MatDialogRef<ExcelViewerComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any,
		private actionSheetController: ActionSheetController,
		private backButtonService: BackButtonService
	) {}

	ngOnInit() {
		// this.id = 1448;
		// this.name = "file_example_XLSX_1000.xlsx";
		this.spreadsheetObj.openUrl = this.environment.env.apiUrl + '/api/document-viewer/OpenExcel';
		this.spreadsheetObj.saveUrl = this.environment.env.apiUrl + '/api/document-viewer/SaveExcel';
	}

	onCreate(): void {
		const data = {
			type: TypeDocument.JobDocument,
			id: this.id,
		};
		this.spreadsheetObj.open({ file: this.id });
	}

	onDocumentChange(): void {}

	cancel() {
		const actionDialogRef = this.dialog.open(ActionDialogComponent, {
			disableClose: true,
			data: {
				title: 'Discard Changes',
				content: 'Are you sure you want to discard the changes you have made to this document? Your action cannot be undone.',
				buttons: [
					{
						title: 'Cancel',
						color: '#41404D',
						action: () => {
							actionDialogRef.close(false);
						},
					},
					{
						title: 'Discard',
						color: '#BC4630',
						action: () => {
							// this.dialogRef.close(true);
							actionDialogRef.close(true);
						},
					},
				],
			},
		});

		actionDialogRef.afterClosed().subscribe(rs => {
			if (rs) {
				this.closed.emit(false);
			}
		});
	}

	beforeSave(args: BeforeSaveEventArgs) {
		args.customParams = {
			id: this.id,
			name: this.name,
			type: TypeDocument.JobDocument,
		};
		args.needBlobData = true;
	}

	saveComplete(args: SaveCompleteEventArgs) {
		this.isLoading = false;
		if (args.status === 'Success') {
			if (this.isSaveAsPdf) {
				this.handleSaveAsPdf();
			} else {
				// close
				this.closed.emit(true);
			}
		}
	}

	save() {
		this.isSaveAsPdf = false;
		const actionDialogRef = this.dialog.open(ActionDialogComponent, {
			disableClose: true,
			data: {
				title: 'Save Changes',
				content: 'Confirm the changes you have made to this document.',
				buttons: [
					{
						title: 'Cancel',
						color: '#41404D',
						action: () => {
							actionDialogRef.close();
						},
					},
					{
						title: 'Save',
						color: '#3E92CC',
						action: () => {
							this.isLoading = true;
							const blob = this.spreadsheetObj.save();
							// actionDialogRef.close();
						},
					},
				],
			},
		});
	}

	saveAsPdf() {
		this.isSaveAsPdf = true;
		// If In Job/ Company Docuemnt, Choose Folder Before Save As Pdf
		if (this.haveChooseDestinationFolder) {
			const dialogRef = this.dialog.open(DestinationFolderDialogDesktopComponent, {
				width: '800px',
				maxHeight: '182px',
				panelClass: 'destination-folder-dialog-desktop',
				data: {
					document: this.document,
				},
			});

			dialogRef.afterClosed().subscribe(rs => {
				if (rs) {
					// destination folder
					// rs: is Parent_Id of document
					this.parentId = rs;
					const blob = this.spreadsheetObj.save();
				}
			});
		} else {
			const blob = this.spreadsheetObj.save();
		}
	}

	KEY_CONVERT_TO_PDF_MOBILE = 'pdfmobile';
	handleSaveAsPdf() {
		this.isLoading = true;
		const data = {
			type: TypeDocument.JobDocument,
			id: this.id,
			doctype: this.doctype,
			parentId: this.parentId,
			jobId: this.jobId,
		};

		if (this.isMobile) {
			this.documentViewerService.SaveAsPdfMobile(data).subscribe(
				(rs: any) => {
					this.isLoading = false;
					let result = {
						key: this.KEY_CONVERT_TO_PDF_MOBILE,
						document: rs,
					};
					this.closed.emit(result);
				},
				error => {
					this.isLoading = false;
					const actionDialogRef = this.dialog.open(ActionDialogComponent, {
						disableClose: true,
						data: {
							title: 'Convert failed',
							content: error.error.Message,
							buttons: [
								{
									title: 'Cancel',
									color: '#41404D',
									action: () => {
										actionDialogRef.close();
									},
								},
								{
									title: 'Try Again',
									color: '#3E92CC',
									action: () => {
										this.saveAsPdf();
									},
								},
							],
						},
					});
				}
			);
		} else {
			this.documentViewerService.SaveAsPdf(data).subscribe(
				(rs: any) => {
					this.isLoading = false;
					// if(this.isMobile) {
					//     this.closed.emit(this.KEY_CONVERT_TO_PDF_MOBILE, );
					// } else {
					this.closed.emit(true);
					this.dialog.open(PdfViewerComponent, {
						maxWidth: '100vw',
						maxHeight: '100vh',
						height: '100%',
						panelClass: 'pdf-popup',
						width: '100%',
						data: {
							id: this.id,
							pdfSrc: rs.File_Url,
							name: rs.File_Name,
						},
					});
					// }
				},
				error => {
					this.isLoading = false;
					const actionDialogRef = this.dialog.open(ActionDialogComponent, {
						disableClose: true,
						data: {
							title: 'Convert failed',
							content: error.error.Message,
							buttons: [
								{
									title: 'Cancel',
									color: '#41404D',
									action: () => {
										actionDialogRef.close();
									},
								},
								{
									title: 'Try Again',
									color: '#3E92CC',
									action: () => {
										this.saveAsPdf();
									},
								},
							],
						},
					});
				}
			);
		}
	}

	// Header Mobile
	public saveExcelSheet: HTMLIonActionSheetElement;
	// Handle Open Camera Or Photo Picker local to choose image upload to photostream
	async openSaveDocument() {
		this.saveExcelSheet = await this.actionSheetController.create({
			buttons: [
				{
					text: 'Save Document',
					handler: () => {
						this.save();
					},
				},
				{
					text: 'Save as PDF',
					handler: () => {
						this.saveAsPdf();
					},
				},
				{
					text: 'Cancel',
					role: 'cancel',
					handler: () => {},
				},
			],
		});

		await this.saveExcelSheet.present();
		this.backButtonService.registerDialog(this.saveExcelSheet, true);
	}
}
